import {
  PanelCard,
  PanelCardContent,
  Panels,
} from 'src/common/components/Layouts/PanelCard/PanelCard';
import { ESimProfilePanelSuspense } from './ESimProfilePanelSuspense';
import { DetailsSkeleton } from 'src/common/components/DetailsSkeleton';

export const ESimDetailsSuspense = () => {
  return (
    <Panels>
      <PanelCard>
        <PanelCardContent>
          <DetailsSkeleton numberOfRepetitions={1} hideBorder />
        </PanelCardContent>
      </PanelCard>
      <ESimProfilePanelSuspense />
      <ESimProfilePanelSuspense />
      <ESimProfilePanelSuspense />
    </Panels>
  );
};
